import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { apiClient, getToken } from 'shared/api';
import { ButtonCustom } from 'shared/ui/button-custom';
import { Loader } from 'shared/ui/loader';
import styles from './referal.module.scss';

export const Referal = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'noId' | 'notFound' | 'authorized' | 'success'>(
    'loading',
  );
  const [message, setMessage] = useState('');

  useEffect(() => {
    const processReferal = async () => {
      const id = searchParams.get('id');

      // Проверка 1: Нет id
      if (!id) {
        setStatus('noId');
        setMessage('Реферальная ссылка не содержит идентификатора');
        return;
      }

      // Проверка 2: Пользователь уже авторизован
      const token = getToken();
      if (token) {
        setStatus('authorized');
        setMessage('Вы уже авторизованы в системе');
        sessionStorage.removeItem('referalId');
        return;
      }

      // Проверка 3: Проверка существования INN в базе данных
      try {
        const response = await apiClient.get(`/agents/checkReferal?id=${id}`);
        const data = response?.data?.data;

        if (!data || !data.exists) {
          setStatus('notFound');
          setMessage('Пользователь с таким реферальным кодом не найден');
          sessionStorage.removeItem('referalId');
          return;
        }

        // Все проверки пройдены - сохраняем в sessionStorage и делаем редирект
        // sessionStorage.setItem('referalId', id);
        setStatus('success');

        // Небольшая задержка перед редиректом для отображения успешного состояния
        setTimeout(() => {
          navigate(`/?referal=${id}`);
        }, 500);
      } catch (error: any) {
        // Если ошибка при запросе, считаем что INN не найден
        setStatus('notFound');
        setMessage('Пользователь с таким реферальным кодом не найден');
        sessionStorage.removeItem('referalId');
      }
    };

    processReferal();
  }, [searchParams, navigate]);

  return (
    <Box className={styles.referalPage}>
      {status === 'loading' || status === 'success' ? (
        <Loader />
      ) : (
        <Box className={styles.messageBox}>
          <span className={styles.message}>{message}</span>
          <ButtonCustom onClick={() => navigate('/')} className={styles.homeButton}>
            Перейти на главную
          </ButtonCustom>
        </Box>
      )}
    </Box>
  );
};
